import { PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import window from 'global/window';
import { isNil, noop } from 'lodash';

// COMPONENTS
import Tooltip from 'components/Tooltip';

// STYLES
import { DropdownMenuContent, DropdownMenuItem, CLASSES } from './DropdownMenu.styles';
import { ifInTestingMode } from 'utils/tests.utils';

class MenuContent extends PureComponent<{ onOutsideClick?: () => void }> {
  FirstItem: any;
  ToolTipNode: any;

  static defaultProps = {
    active: true,
    className: '',
    showIcon: true,
    onOutsideClick: noop,
  };

  static getItemList = (items, intl, getItemClickHandler, showIcon = true) =>
    items.map((item, index) => {
      const renderedValue = item.get('renderedValue');
      const disabled = item.get('disabled', false);

      let testId = `dropdown-menu__item__${item.get('id')}`;
      let displayText = String(item.get('value'));
      const icon = item.get('icon')?.toJS();
      let translationId = null;
      let values = null;
      let className = '';
      let handleClick = null;

      if (!isNil(renderedValue)) {
        if (typeof renderedValue === 'object') {
          translationId = renderedValue.get('translationId');
          values = renderedValue.get('values')?.toJS();
        } else {
          displayText = renderedValue;
        }
      }

      if (!isNil(translationId)) {
        translationId;

        const stringExists = Boolean(intl.messages[translationId]);
        displayText = stringExists ? <FormattedMessage id={translationId} values={values} /> : translationId;
      }

      if (disabled !== true) {
        handleClick = (event) => {
          return getItemClickHandler(item, index, event);
        };
      } else {
        testId += '--disabled';
        className = CLASSES.DISABLED;
      }

      return (
        <DropdownMenuItem
          key={item.get('id') ?? displayText}
          data-testid={ifInTestingMode(testId)}
          onMouseDown={handleClick}
          className={className}
        >
          {Boolean(icon) && showIcon && icon}
          <div key={`${item.get('id')}-text`}>{displayText}</div>
        </DropdownMenuItem>
      );
    });

  state = {
    calculatedMaxHeight: null,
    itemList: MenuContent.getItemList(
      // @ts-expect-error TS(2339): Property 'items' does not exist on type 'Readonly<... Remove this comment to see the full error message
      this.props.items,
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl,
      // @ts-expect-error TS(2339): Property 'getItemClickHandler' does not exist on t... Remove this comment to see the full error message
      this.props.getItemClickHandler,
      // @ts-expect-error TS(2339): Property 'showIcon' does not exist on type 'Readon... Remove this comment to see the full error message
      this.props.showIcon
    ),
    modalElement: null,
    stashedProps: {
      // @ts-expect-error TS(2339): Property 'items' does not exist on type 'Readonly<... Remove this comment to see the full error message
      items: this.props.items,
    },
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    const { items } = nextProps;
    const prevItems = prevState.stashedProps.items;

    if (!items.equals(prevItems)) {
      const itemList = MenuContent.getItemList(items, nextProps.intl, nextProps.getItemClickHandler);

      return {
        itemList,
        stashedProps: {
          items,
        },
      };
    }

    return null;
  };

  componentDidMount() {
    this.handleModalParent();
  }

  componentDidUpdate() {
    const scrollTop = this.getScrollTop();

    const { ToolTipNode } = this;

    if (ToolTipNode && !isNil(scrollTop)) {
      ToolTipNode.InnerMenuContent.scrollTop = scrollTop;
    }

    // @ts-expect-error TS(2339): Property 'maxItems' does not exist on type 'Readon... Remove this comment to see the full error message
    if (this.props.maxItems > 0 && this.state.calculatedMaxHeight === null && this.getItemHeight() !== null) {
      const calculatedMaxHeight = this.getMaxMenuHeight();
      this.setState({ calculatedMaxHeight });
    }
  }

  componentWillUnmount() {
    if (this.state.modalElement && this.handleScroll) {
      this.state.modalElement.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleModalParent = () => {
    const modalElement = document.getElementById('relative-modal');

    if (modalElement && this.handleScroll) {
      modalElement.addEventListener('scroll', this.handleScroll);
    }

    this.setState({ modalElement });
  };

  handleScroll = () => {
    window.requestAnimationFrame(this.forceUpdate.bind(this, noop));
  };

  // handleScroll: ?() => void = null;

  // ToolTipNode: ?typeof Tooltip = null;

  // FirstItem: ?HTMLElement = null;

  getItemHeight = () => (this.FirstItem ? this.FirstItem.clientHeight : null);

  getMaxMenuHeight = () => {
    // @ts-expect-error TS(2339): Property 'maxItems' does not exist on type 'Readon... Remove this comment to see the full error message
    const { maxItems } = this.props;
    const itemHeight = this.getItemHeight();

    if (!isNil(maxItems) && !isNil(itemHeight)) {
      return maxItems * itemHeight;
    }

    return null;
  };

  getScrollTop = () => {
    // @ts-expect-error TS(2339): Property 'focusedIndex' does not exist on type 'Re... Remove this comment to see the full error message
    const { focusedIndex } = this.props;
    const { ToolTipNode } = this;
    const itemHeight = this.getItemHeight();

    if (!ToolTipNode || !ToolTipNode.InnerMenuContent || !itemHeight) {
      return null;
    }

    const { scrollTop } = ToolTipNode.InnerMenuContent;
    const maxMenuHeight = this.getMaxMenuHeight();

    if (isNil(maxMenuHeight) || maxMenuHeight === 0 || focusedIndex < 0) {
      return null;
    }

    // The px offset from the top of the container to the bottom of
    // the focused item.
    const focusedItemOffset = (focusedIndex + 1) * itemHeight;

    if (itemHeight && (maxMenuHeight + scrollTop < focusedItemOffset || scrollTop >= focusedItemOffset)) {
      return focusedItemOffset - maxMenuHeight;
    }

    return null;
  };

  getContent() {
    let { itemList } = this.state;
    // @ts-expect-error TS(2339): Property 'ContentWrapper' does not exist on type '... Remove this comment to see the full error message
    const { ContentWrapper } = this.props;
    // Set FirstItem ref for height calculations

    if (itemList.size) {
      itemList = itemList.update(0, (props) => ({
        ...props,
        ref: (elem) => (this.FirstItem = elem),
      }));

      if (
        // there is a focused item
        // @ts-expect-error TS(2339): Property 'focusedIndex' does not exist on type 'Re... Remove this comment to see the full error message
        this.props.focusedIndex > -1 &&
        // the focused item is in range with the total list element (elements can be removed from the list)
        // @ts-expect-error TS(2339): Property 'focusedIndex' does not exist on type 'Re... Remove this comment to see the full error message
        itemList.size > this.props.focusedIndex
      ) {
        itemList = itemList.updateIn(
          // @ts-expect-error TS(2339): Property 'focusedIndex' does not exist on type 'Re... Remove this comment to see the full error message
          [this.props.focusedIndex, 'props', 'className'],
          (className) => `${className} ${CLASSES.FOCUSED}`
        );
      }
    }

    const content = (
      <DropdownMenuContent data-testid={ifInTestingMode('dropdow-menu__content')}>{itemList}</DropdownMenuContent>
    );

    if (!isNil(ContentWrapper)) {
      return <ContentWrapper>{content}</ContentWrapper>;
    }

    return content;
  }

  render() {
    // @ts-expect-error TS(2339): Property 'active' does not exist on type 'Readonly... Remove this comment to see the full error message
    const { active, className } = this.props;
    const content = this.getContent();

    return (
      // @ts-expect-error TS(2322): Type '{ children: Element; ref: (elem: unknown) =>... Remove this comment to see the full error message
      <Tooltip
        ref={(elem) => (this.ToolTipNode = elem)}
        className={className}
        isShown={active}
        maxHeight={this.state.calculatedMaxHeight}
        onOutsideClick={this.props.onOutsideClick}
        // @ts-expect-error TS(2339): Property 'containerElement' does not exist on type... Remove this comment to see the full error message
        containerElement={this.props.containerElement}
        offset={10}
      >
        {content}
      </Tooltip>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(MenuContent);
